<script setup lang="ts">
import { TSDialogConfirm, useLoadingStore, useToast } from 'tsv2-library';

import BorrowingServices from '@/services/borrowing.service';

import {
  BorrowingBorrowedByAsset,
  BorrowingTransactionRequest,
} from '@/types/borrowing.type';

const toast = useToast();
const { setLoading } = useLoadingStore();

const visible = defineModel<boolean>('visible', { required: true });

const props = defineProps<{
  selectedData: BorrowingTransactionRequest[] | BorrowingBorrowedByAsset[];
  tableName: string;
}>();

const handleCancelReport = async (): Promise<void> => {
  try {
    setLoading(true);

    await BorrowingServices.putCancelReportBulk(
      props.selectedData.map((datum) => datum._id),
    );

    toast.add({
      message: 'Success, report has been canceled.',
      severity: 'success',
    });

    dispatchEvent(
      new CustomEvent('updateTable', {
        detail: {
          tableName: props.tableName,
        },
      }),
    );
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to cancel report.',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};
</script>
<template>
  <TSDialogConfirm
    v-model:visible="visible"
    @confirm="handleCancelReport"
    confirm-label="Continue"
    data-ts-name="cancel-report"
    header="Cancel Report"
    modal
    severity="danger"
  >
    <template #body>
      <span>This action will cancel the report.</span>
      <span>Are you sure want to continue?</span>
    </template>
  </TSDialogConfirm>
</template>
